<script lang="ts">
    import type {DayOptimisationJobTypeSummary} from '../../reports-optimisation-tab/overviews/types';
    import {getColorFromString} from 'shared/utils/color-util';
    import {jobColorLightness} from '../../reports-optimisation-tab/overviews/types';

    export let jobTypeSummary: DayOptimisationJobTypeSummary;
</script>

<div class="day-overview-card">
    <div class="card-header">
        <div class="job-type-color"
             style:background-color="{getColorFromString(jobTypeSummary.name, jobColorLightness)}"></div>

        <span class="job-name">{jobTypeSummary.name}</span>
    </div>

    <div class="card-body">
        <span class="job-hours">Standartní pracovní doba: <span class="hours-value">{jobTypeSummary.standardHours}</span></span>
        <span class="job-hours">Přesčas: <span class="hours-value">{jobTypeSummary.overtimeHours}</span></span>
        <span class="job-hours">Víkend: <span class="hours-value">{jobTypeSummary.weekendHours}</span></span>
        <span class="job-hours">Svátek: <span class="hours-value">{jobTypeSummary.holidayHours}</span></span>
    </div>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .day-overview-card {
        padding: @spacing-ml @spacing-l;
        background-color: @themed-panel-bg;
        border-radius: @border-radius-large;
        border: 1px solid @themed-border-default;
        display: flex;
        flex-direction: column;
        gap: @spacing-sm;
        width: 100%;

        .card-header {
            display: flex;
            align-items: center;
            gap: @spacing-s;

            .job-type-color {
                width: 16px;
                height: 16px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                border-radius: @border-radius-sm;
            }

            .job-name {
                font-weight: 500;
            }
        }

        .card-body {
            display: flex;
            flex-direction: column;
            gap: @spacing-s;

            .job-hours {
                font-size: @font-size-small;
                color: @themed-text-muted;

                .hours-value {
                    font-weight: 500;
                    color: @themed-text-default;
                }
            }
        }
    }
</style>